import { DefaultValue } from 'recoil';
import { unStringfy } from '../utils/functions';

export const localPersistEffect = ({ onSet, setSelf, node }: any) => {
  const storedItems = localStorage.getItem(node.key);
  if (storedItems != null) {
    setSelf(unStringfy(storedItems));
  }

  onSet((newItems: any) => {
    if (newItems instanceof DefaultValue) {
      localStorage.removeItem(node.key);
    } else {
      localStorage.setItem(node.key, JSON.stringify(newItems));
    }
  });
};
